<div class="page-sub-title">Barn Availability</div>

<div class="barn-toolbar">
  <div class="week-nav" *ngIf="activeView === 'calendar'">
    <button class="nav-button" (click)="changeWeek(-1)" aria-label="Previous week">&lsaquo;</button>
    <button class="week-label" (click)="goToThisWeek()">{{ weekLabel }}</button>
    <button class="nav-button" (click)="changeWeek(1)" aria-label="Next week">&rsaquo;</button>
  </div>

  <div class="week-nav" *ngIf="activeView === 'upcoming'">
    <button class="nav-button" (click)="showCalendarView()" aria-label="Back to calendar">&lsaquo;</button>
    <span class="week-label static-label">Upcoming Bookings</span>
  </div>

  <div class="admin-menu" *ngIf="isTeeTimeAdmin">
    <button
      type="button"
      class="gear-button"
      aria-label="Barn settings"
      aria-haspopup="true"
      [attr.aria-expanded]="adminMenuOpen"
      (click)="toggleAdminMenu($event)">
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <path
          fill="currentColor"
          d="M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.63-.06-.94l2.03-1.58a.5.5 0 0 0 .12-.64l-1.92-3.32a.5.5 0 0 0-.6-.22l-2.39.96a7.03 7.03 0 0 0-1.63-.94l-.36-2.54a.5.5 0 0 0-.5-.42h-3.84a.5.5 0 0 0-.5.42l-.36 2.54c-.59.24-1.13.55-1.63.94l-2.39-.96a.5.5 0 0 0-.6.22L2.77 8.84a.5.5 0 0 0 .12.64l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94L2.89 14.52a.5.5 0 0 0-.12.64l1.92 3.32c.14.24.43.34.68.22l2.39-.96c.5.39 1.04.71 1.63.94l.36 2.54c.05.24.26.42.5.42h3.84c.24 0 .45-.18.5-.42l.36-2.54c.59-.24 1.13-.55 1.63-.94l2.39.96c.25.1.54 0 .68-.22l1.92-3.32a.5.5 0 0 0-.12-.64l-2.03-1.58zM12 15.6A3.6 3.6 0 1 1 12 8.4a3.6 3.6 0 0 1 0 7.2z"/>
      </svg>
    </button>

    <div class="admin-menu-panel" *ngIf="adminMenuOpen" role="menu" (click)="$event.stopPropagation()">
      <button type="button" role="menuitem" (click)="onAdminMenuAction('upcoming')">Upcoming Bookings</button>
      <button type="button" role="menuitem" (click)="onAdminMenuAction('blackout')">Block Time</button>
      <button type="button" role="menuitem" (click)="onAdminMenuAction('notifications')">Notifications</button>
    </div>
  </div>
</div>

<div class="banner error" *ngIf="activeView === 'calendar' && errorMessage">{{ errorMessage }}</div>
<div class="banner error" *ngIf="activeView === 'upcoming' && upcomingError">{{ upcomingError }}</div>
<div class="banner notice" *ngIf="noticeMessage" (click)="dismissNotice()">{{ noticeMessage }}</div>

<ng-container *ngIf="activeView === 'calendar'">
<div class="day-strip" *ngIf="isNarrowScreen">
  <button
    *ngFor="let day of days; let i = index"
    class="day-chip"
    [ngClass]="{ 'selected': i === selectedDayIndex, 'today': day.isToday }"
    (click)="selectDay(i)">
    <span class="chip-day">{{ day.dayName }}</span>
    <span class="chip-number">{{ day.dayNumber }}</span>
    <span class="chip-open">{{ day.openSlotCount ? day.openSlotCount + ' open' : 'full' }}</span>
  </button>
</div>

<div class="calendar">
  <div class="calendar-head">
    <div class="gutter-head"></div>
    <div class="day-head" *ngFor="let day of visibleDays" [ngClass]="{ 'today': day.isToday }">
      <span class="head-day">{{ day.dayName }}</span>
      <span class="head-number">{{ day.dayNumber }}</span>
    </div>
  </div>

  <div class="calendar-body">
    <div class="time-gutter">
      <div class="gutter-slot" *ngFor="let minute of gridSlotMinutes">
        <span *ngIf="isHourStart(minute)">{{ formatMinute(minute) }}</span>
      </div>
    </div>

    <div class="day-column" *ngFor="let day of visibleDays">
      <div class="slot-layer">
        <button
          type="button"
          class="slot"
          *ngFor="let slot of day.slots"
          [ngClass]="{ 'bookable': slot.isBookable }"
          [disabled]="!slot.isBookable"
          [title]="formatMinute(slot.startMinute)"
          (click)="openReserveModal(day, slot)">
          <span class="slot-hint" *ngIf="slot.isBookable">{{ formatMinute(slot.startMinute) }}</span>
        </button>
      </div>

      <button
        type="button"
        class="event"
        *ngFor="let event of day.events"
        [ngClass]="{ 'blackout': event.isBlackout, 'mine': event.isMine }"
        [style.top.%]="event.topPercent"
        [style.height.%]="event.heightPercent"
        (click)="openDetailsModal(event)">
        <span class="event-title">{{ event.title }}</span>
        <span class="event-time">{{ event.timeRange }}</span>
      </button>
    </div>
  </div>
</div>

<div class="legend">
  <span class="legend-item"><i class="swatch open"></i>Open</span>
  <span class="legend-item"><i class="swatch taken"></i>Reserved</span>
  <span class="legend-item"><i class="swatch mine"></i>Yours</span>
  <span class="legend-item"><i class="swatch blocked"></i>Blocked</span>
</div>
</ng-container>

<div class="upcoming-list" *ngIf="activeView === 'upcoming'">
  <button
    type="button"
    class="upcoming-row"
    *ngFor="let booking of upcomingBookings"
    (click)="openUpcomingDetails(booking)">
    <div class="upcoming-when">
      <span class="upcoming-date">{{ formatUpcomingDate(booking.startAt) }}</span>
      <span class="upcoming-time">{{ formatUpcomingTime(booking) }}</span>
    </div>
    <div class="upcoming-players">{{ upcomingPlayers(booking) }}</div>
  </button>

  <div class="empty-hint" *ngIf="!upcomingError && upcomingBookings.length === 0">
    No upcoming reservations.
  </div>
</div>

<!-- Reserve -->
<div class="modal-overlay" *ngIf="activeModal === 'RESERVE'">
  <div class="modal-sheet">
    <div class="modal-title">Reserve the Barn</div>
    <div class="modal-subtitle">{{ reserveHeading }} &middot; {{ reserveTimeRange }}</div>

    <div class="banner error" *ngIf="modalError">{{ modalError }}</div>

    <form class="form form-full-width">
      <div class="field">
        <select [(ngModel)]="reserveDuration" name="reserveDuration">
          <option *ngFor="let option of reserveDurationOptions" [ngValue]="option">{{ formatDuration(option) }}</option>
        </select>
        <label class="static">How long</label>
      </div>

      <div class="who-block">
        <div class="who-title">Who is playing</div>
        <div class="booker-chip">{{ currentPlayerName }} (you)</div>

        <div class="checkbox-list scroll-list">
          <label class="checkbox-item" *ngFor="let player of selectableRoster">
            <input
              type="checkbox"
              [checked]="isPlayerSelected(player.id)"
              (change)="togglePlayer(player.id, $any($event.target).checked)" />
            <span class="checkbox-label">{{ player.firstName }} {{ player.lastName }}</span>
          </label>
        </div>

        <div class="guest-row" *ngFor="let guest of reserveGuestNames; let i = index; trackBy: trackByIndex">
          <input type="text" class="guest-input" placeholder="Guest name" [(ngModel)]="reserveGuestNames[i]" [name]="'guest' + i" />
          <button type="button" class="guest-remove" (click)="removeGuest(i)">Remove</button>
        </div>

        <button type="button" class="tiny" (click)="addGuest()">Add Guest</button>
      </div>

      <button type="button" (click)="saveReservation()">Reserve</button>
      <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
    </form>
  </div>
</div>

<!-- Details -->
<div class="modal-overlay" *ngIf="activeModal === 'DETAILS' && detailsEvent">
  <div class="modal-sheet">
    <div class="modal-title">{{ detailsEvent.title }}</div>
    <div class="modal-subtitle">{{ detailsEvent.timeRange }}</div>

    <div class="banner error" *ngIf="modalError">{{ modalError }}</div>

    <div class="details-body">
      <div *ngIf="!detailsEvent.isBlackout && detailsPlayerNames">
        <div class="who-title">Playing</div>
        <div class="details-players">{{ detailsPlayerNames }}</div>
      </div>
      <div *ngIf="detailsEvent.isBlackout" class="details-players">
        The barn is blocked off during this time.
      </div>
    </div>

    <button type="button" *ngIf="detailsEvent.booking.canCancel && !detailsEvent.isBlackout" class="danger" (click)="cancelBooking(false)">
      Cancel This Tee Time
    </button>
    <button type="button" *ngIf="detailsEvent.booking.canCancel && detailsEvent.isBlackout" class="danger" (click)="cancelBooking(false)">
      Remove This Block
    </button>
    <button type="button" *ngIf="detailsEvent.booking.canCancel && detailsEvent.isBlackout && detailsEvent.booking.blackoutRuleId" class="danger" (click)="cancelBooking(true)">
      Remove Whole Series
    </button>
    <button type="button" class="cancel" (click)="closeModal()">Close</button>
  </div>
</div>

<!-- Notifications -->
<div class="modal-overlay" *ngIf="activeModal === 'NOTIFICATIONS'">
  <div class="modal-sheet">
    <div class="modal-title">Booking Notifications</div>
    <div class="modal-subtitle">Email these people when someone reserves the barn</div>

    <div class="banner error" *ngIf="modalError">{{ modalError }}</div>

    <form class="form form-full-width">
      <div class="who-block">
        <div class="checkbox-list scroll-list">
          <label class="checkbox-item" *ngFor="let player of notificationRoster">
            <input
              type="checkbox"
              [checked]="isNotificationRecipient(player.id)"
              (change)="toggleNotificationRecipient(player.id, $any($event.target).checked)" />
            <span class="checkbox-label">
              {{ player.firstName }} {{ player.lastName }}
              <span class="checkbox-email">{{ player.email }}</span>
            </span>
          </label>
        </div>
        <div class="empty-hint" *ngIf="notificationRoster.length === 0">
          No players have an email address on file yet.
        </div>
      </div>

      <button type="button" (click)="saveNotifications()">Save</button>
      <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
    </form>
  </div>
</div>

<!-- Blackout -->
<div class="modal-overlay" *ngIf="activeModal === 'BLACKOUT'">
  <div class="modal-sheet">
    <div class="modal-title">Block Barn Time</div>

    <div class="banner error" *ngIf="modalError">{{ modalError }}</div>

    <form class="form form-full-width">
      <div class="repeat-toggle">
        <button type="button" [ngClass]="{ 'selected': !blackoutIsRecurring }" (click)="blackoutIsRecurring = false">One Time</button>
        <button type="button" [ngClass]="{ 'selected': blackoutIsRecurring }" (click)="blackoutIsRecurring = true">Repeating</button>
      </div>

      <div class="field" *ngIf="!blackoutIsRecurring">
        <input type="date" [(ngModel)]="blackoutDate" name="blackoutDate" placeholder=" " />
        <label class="static">Date</label>
      </div>

      <div *ngIf="blackoutIsRecurring">
        <div class="who-title">Days</div>
        <div class="dow-row">
          <button
            type="button"
            class="dow-button"
            *ngFor="let option of dayOfWeekOptions"
            [ngClass]="{ 'selected': isBlackoutDaySelected(option.value) }"
            (click)="toggleBlackoutDay(option.value)">
            {{ option.name }}
          </button>
        </div>
      </div>

      <div class="field">
        <select [(ngModel)]="blackoutStartMinute" name="blackoutStart">
          <option *ngFor="let minute of blackoutTimeOptions" [ngValue]="minute">{{ formatMinute(minute) }}</option>
        </select>
        <label class="static">Starts at</label>
      </div>

      <div class="field">
        <select [(ngModel)]="blackoutEndMinute" name="blackoutEnd">
          <option *ngFor="let minute of blackoutTimeOptions" [ngValue]="minute">{{ formatMinute(minute) }}</option>
        </select>
        <label class="static">Ends at</label>
      </div>

      <div class="field" *ngIf="blackoutIsRecurring">
        <input type="date" [(ngModel)]="blackoutStartsOn" name="blackoutStartsOn" placeholder=" " />
        <label class="static">Starts on</label>
      </div>

      <div class="field" *ngIf="blackoutIsRecurring">
        <input type="date" [(ngModel)]="blackoutEndsOn" name="blackoutEndsOn" placeholder=" " />
        <label class="static">Ends on (optional)</label>
      </div>

      <div class="field">
        <input type="text" [(ngModel)]="blackoutLabel" name="blackoutLabel" placeholder=" " maxlength="40" />
        <label>Label (Private, League Night)</label>
      </div>

      <button type="button" (click)="saveBlackout()">Block It</button>
      <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
    </form>
  </div>
</div>
